export default __webpack_public_path__ + "static/musk-logo-rush-4315e7a2691cedc2610fecb0d202a20a.png";